export default function ProcessSteps() {
  const steps = [
    {
      title: "Application Plan",
      description: "Defining priorities and crafting a strategy to support your applications",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      )
    },
    {
      title: "University Shortlisting",
      description: "Identifying dream, target, and safety schools aligned with your goals",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      title: "Essay & Document Support",
      description: "Guiding SOP brainstorming, resume creation, and recommendation letters",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      title: "Interview Preparation",
      description: "Practice interviews with feedback and coaching for video essay success",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
        </svg>
      )
    },
    {
      title: "Review Final Decisions",
      description: "Evaluate your offers and get advice on making the final decision",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9.5a2.5 2.5 0 00-2.5-2.5H15M9 11l3 3L9 17" />
        </svg>
      )
    },
  ];
  

  return (
    <div className="bg-white py-24">
      <div className="max-w-screen-lg mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-2xl md:text-2xl lg:text-5xl notoh font-bold text-center mx-2">
            5 Steps to a Competitive Application
          </h1>
        </div>

        <div className="flex flex-wrap gap-8 justify-center items-center lg:mx-0 mx-4 ">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-gray-100 rounded-2xl p-8 transition-transform hover:-translate-y-1 md:w-[30%] h-[230px]"
            >
              <h3 className="text-black text-xl font-semibold mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 mb-8">
                {step.description}
              </p>
              <div className="absolute bottom-6 right-6"> 
                <div className="relative flex items-center justify-center">
                  {/* Semicircle Border */}
                 

                  {/* Icon */}
                  <div className="relative z-20 text-gray-400">{step.icon}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}